import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import mixin from 'react-mixin';

import { ModalStore, ModalActions } from '../../stores/modal_store';
import { FlashMessageAPI } from 'lecom-api';
import FlashMessageStoreItem from '../../../flash_message/models/flash_messages_store_item.js';
import ScreenSizes from 'screen_sizes';

@mixin.decorate(Reflux.listenTo(ModalStore, 'onModalAction'))
@mixin.decorate(window.CssClassMixin)
@mixin.decorate(window.ContainerMixin)
export default class Modal extends React.Component {
	static propTypes = {
		id: PropTypes.string,
		opened: PropTypes.bool,
		marginHeaderFooter: PropTypes.number,
		width: PropTypes.string,
		minContentHeight: PropTypes.number,
		useAvailableHeight: PropTypes.bool,
		resizer: PropTypes.func,

		dismissible: PropTypes.bool,
		opacity: PropTypes.number,
		inDuration: PropTypes.number,
		outDuration: PropTypes.number,
		ready: PropTypes.func,
		complete: PropTypes.func,

		isMobile: PropTypes.bool,
	};

	static defaultProps = {
		id: '',
		themeClassKey: 'modal',
		opened: false,
		marginHeaderFooter: 100,
		width: '60%',
		minContentHeight: 0,
		useAvailableHeight: false,
		resizer: null,

		dismissible: true,
		opacity: 0.4,
		inDuration: 300,
		outDuration: 200,
		ready: function() { return true; },
		complete: function() { return true; },

		isMobile: false,
	};

	state = {
		modalStore: null,
		storeCallback: null
	};

	constructor(props) {
		super(props);

		this.setContentHeight = this.setContentHeight.bind(this);
		this.resizer = props.resizer || this.setContentHeight;
		this.resizer = this.resizer.bind(this, this, this.setContentHeight);
		this.isMobile = props.isMobile || window.innerWidth <= ScreenSizes.SMALL_SCREEN_WIDTH;
	}

	componentDidMount () {
		this.resizer();
		$(window).on('resize', this.resizer);

		if(!!this.props.opened) {
			this.open();
		}
	}

	componentWillUnmount () {
		$(window).off('resize', this.resizer);
	}

	componentDidUpdate () {
		this.resizer();
		if(!!this.state.opened) {
			this.open();
		}

		if(this.state.modalStore) {
			this.handleModalStoreState();
		}

		setTimeout(() => {
			const leanOverlay = $(".lean-overlay");
			const realizeModal = $(".card.realize-modal");
			const searcherModal = $(".searcher-field__modals-wrapper");
			const searcherModalIsEmpty = $(".searcher-field__modals-wrapper > span").length > 0;
			const leanOverlayIsVisible = leanOverlay.length;
			const searcherModalWidth = searcherModal.css("width") || '0px';
			const importMultipleModal = $(".container-import-multiple-modal");
			const importMultipleModalOpen = $(".container-import-multiple-modal.open").length > 0;
			const importMultipleGridModal = $(".container-import-multiple-grid-modal");
			const importMultipleModalGridOpen = $(".container-import-multiple-grid-modal.open").length > 0;


			let realizeModalIsVisible = 0;

			$.each(realizeModal, (key, elem) => {
				if ($(elem).css("display") !== 'none') {
					realizeModalIsVisible = realizeModalIsVisible + 1;
				}
			});

			if (leanOverlayIsVisible > realizeModalIsVisible) {
				leanOverlay.last().remove();
			} else if (leanOverlayIsVisible === 1 && realizeModalIsVisible === 1 && searcherModalWidth !== '0px') {
				const zIndex = Number(leanOverlay.css("z-index") || 0) + 1;
				searcherModal.css("z-index", zIndex);
			} else if (leanOverlayIsVisible === 1 && realizeModalIsVisible === 1 && importMultipleModalOpen) {
				const zIndex = Number(leanOverlay.css("z-index") || 0) + 1;
				importMultipleModal.css("z-index", zIndex);
			} else if (leanOverlayIsVisible === 1 && realizeModalIsVisible === 1 && importMultipleModalGridOpen && this.isMobile) {
				leanOverlay.css("z-index", 1002);
				importMultipleGridModal.css("z-index", 1003);
			}

			if ($(".lean-overlay").length === 0 && realizeModalIsVisible === 0 && searcherModalWidth !== '0px' && searcherModalIsEmpty) {
				searcherModal.css({ "z-index": "-1", "width": "0px", "height": "0px" });
			}

			if ($(".lean-overlay").length === 0 && realizeModalIsVisible === 0 && importMultipleModalOpen) {
				importMultipleModal.removeClass("open");
			}
		}, 1000);
	}

	onModalAction(storeData, callback) {
		this.setState({
			modalStore: storeData,
			storeCallback: callback
		});
	}

	renderHeader () {
		return (
			<div ref="headerContainer" className="modal-header-container">
			{this.filterChildren(ModalHeader)}
			</div>
		);
	}

	renderContent () {
		if (this.isMobile) {
			return (
				<div ref="contentContainer" className="modal-content-container">
					<div className="modal-content-overflow">
						{this.filterChildren(ModalContent)}
					</div>
				</div>
			);
		}

		return (
			<div ref="contentContainer" className="modal-content-container">
				{this.filterChildren(ModalContent)}
			</div>
		);
	}

	renderFooter () {
		return (
			<div ref="footerContainer" className="modal-footer-container">
			{this.filterChildren(ModalFooter)}
			</div>
		);
	}

	render () {
		var header = this.filterChildren(ModalHeader)? this.renderHeader() : '';
		var content = this.filterChildren(ModalContent)? this.renderContent() : '';
		var footer = this.filterChildren(ModalFooter)? this.renderFooter() : '';
		var modalMobileClass = '';
		var styleMobile = {};

		if(header == '' && content == '' && footer == '')
			content = (<ModalContent {...this.props}>{this.props.children}</ModalContent>);

		if (this.isMobile) {
			modalMobileClass = 'modal-mobile';
		}

		return (
			<div id={this.props.id} className={`${this.className()} ${modalMobileClass}`} ref="modal" style={styleMobile}>
				{header}
				{content}
				{footer}
			</div>
		);
	}

	handleModalStoreState () {
		var modalStore = this.state.modalStore;
		var shouldOpenModal = modalStore.shouldOpen;
		var shouldCloseModal = modalStore.shouldClose;
		var modalToOpenId = modalStore.modalId;

		if(modalToOpenId == this.props.id) {
			if(shouldOpenModal) {
				this.open();
			}

			if(shouldCloseModal) {
				this.close();
			}
		}
	}

	focusTitleModal(){
		setTimeout(() => {
			let idModal = this.props.id;

			if($(`#${idModal}`).is(':visible')){
				$(`#${idModal} .modal-header span`).unbind('keydown').keydown(function(e) {
					if(e.shiftKey){
						if(e.shiftKey && e.keyCode === 9)
							return false
					}
				})
			}
		}, 500);
	}

	open(options) {
		var $modal = $(ReactDOM.findDOMNode(this.refs.modal));

		$modal.openModal({
			dismissible: this.props.dismissible,
			opacity: this.props.opacity,
			in_duration: this.props.inDuration,
			out_duration: this.props.outDuration,
			ready: this.handleReady.bind(this),
			complete: this.handleComplete.bind(this)
		});

		if (this.refs.modal && this.refs.modal.id && this.refs.modal.id.match(/\lookup-modal/g)) {
			FlashMessageAPI.flash('flash-search-modal').clear();
		}

		this.state.modalStore.shouldOpen = false;

		if (this.isMobile) {
			var headerContainer = ReactDOM.findDOMNode(this.refs.headerContainer);
			var contentContainer = ReactDOM.findDOMNode(this.refs.contentContainer);
			var footerContainer = ReactDOM.findDOMNode(this.refs.footerContainer);

			$(contentContainer).css({
				"paddingTop": $(headerContainer).height() + "px",
    			"paddingBottom": $(footerContainer).height() + "px"
			});
		}

		this.focusTitleModal();

		if ($modal) {
			const $wrapper = $modal.parent(".searcher-field__modals-wrapper");
			const isCustomModalApi = $modal.attr("id") === "custom-modal-api";

			if ($wrapper) {
				if (this.isMobile) {
					$wrapper.css({ zIndex: "1005", width: "100%", height: "calc(100% - 20px)" });
				}
				else {
					if (window.importMultipleGridOpen) {
						const $wrapperChildren = $wrapper.find(".modalLupa");
						const containerImportMultipleGridModal = $(".container-import-multiple-grid-modal");
						const childrenImportMultipleGridModal = $("#importMultipleGridModal");

						$wrapper.css({ zIndex: "1005", width: "100%", height: "100%" });

						if ($wrapper.css("zIndex") && $wrapper.css("zIndex") !== "-1" && $wrapper.css("zIndex") !== $wrapperChildren.css("zIndex")) {
							$wrapper.css("zIndex", $wrapperChildren.css("zIndex"));
						}

						if (containerImportMultipleGridModal.css("zIndex") !== childrenImportMultipleGridModal.css("zIndex")) {
							containerImportMultipleGridModal.css("zIndex", childrenImportMultipleGridModal.css("zIndex"));
						}
					}
					else {
						$wrapper.css({ zIndex: "1003", width: "100%", height: "100%" });
					}
				}
			}

			if (this.isMobile && !isCustomModalApi) {
				$modal.css({ zIndex: "1003" });
				$(".lean-overlay").css({ zIndex: "1002" });
			}

			if (isCustomModalApi) {
				const lastOverlay = $(".lean-overlay:last-child");

				lastOverlay.css({ zIndex: "1010" });
				$modal.css({ zIndex: "1011" });
			}

			$modal.css({ display: 'flex', flexDirection: "column" });

			setTimeout(() => {
				if ($(".container-export-multiple-modal").hasClass("open")) {
					const zIndexContainerModalExport = Number($(".container-export-multiple-modal").css("zIndex") || 0);
					const zIndexOverlay = Number($(".lean-overlay").css("zIndex") || 0);

					if (zIndexOverlay >= zIndexContainerModalExport) {
						$(".lean-overlay").css("zIndex", zIndexContainerModalExport - 1)
					}
				}
			}, 500);
		}
	}

	handleReady() {
		this.resizer();
		this.handleStoreCallback();
		ModalActions.openFinished();

		if(typeof this.props.ready === "function") {
			this.props.ready();
		}
	}

	handleComplete() {
		this.handleStoreCallback();
		ModalActions.closeFinished();

		if(typeof this.props.complete === "function") {
			this.props.complete();
		}
	}

	handleStoreCallback() {
		if(!!this.state.storeCallback && typeof this.state.storeCallback === "function") {
			this.state.storeCallback();
			this.setState({ storeCallback: null });
		}
	}

	close() {
		var $modal = $(ReactDOM.findDOMNode(this.refs.modal));

		$modal.closeModal();
		this.handleComplete();

		this.state.modalStore.shouldClose = false;

		if ($modal) {
			const $wrapper = $modal.parent(".searcher-field__modals-wrapper");

			if ($wrapper) {
				$wrapper.css({ zIndex: "-1", width: "0px", height: "0px" });

				if (!window.importMultipleGridOpen) {
					const containerImportMultipleGridModal = $(".container-import-multiple-grid-modal");
					containerImportMultipleGridModal.css("zIndex", "-1");
				}
			}

			setTimeout(() => {
				if ($(".container-export-multiple-modal").hasClass("open") && $("#exportMultipleModal").css("display") === "none") {
					$(".container-export-multiple-modal").removeClass("open");
				}
			}, 500);
		}
	}

	setContentHeight() {
		var modal = ReactDOM.findDOMNode(this.refs.modal);
		var contentContainer = ReactDOM.findDOMNode(this.refs.contentContainer);

		if (!this.isMobile) {
			$(modal).css("max-height", $(window).height() - (this.props.marginHeaderFooter / 2));
			$(modal).css("width", this.props.width);

			var availableHeight = this.getAvailableHeight();
			var contentHeight = this.getContentHeight();
			var containerHeight = 0;

			if(!!this.props.useAvailableHeight) {
				containerHeight = availableHeight;
			} else {
				containerHeight = Math.min(availableHeight, contentHeight);
			}

			$(contentContainer).css("height", containerHeight);
		}
	}

	getAvailableHeight () {
		var headerContainer = ReactDOM.findDOMNode(this.refs.headerContainer);
		var footerContainer = ReactDOM.findDOMNode(this.refs.footerContainer);

		return ($(window).height() - (this.props.marginHeaderFooter)) - ($(headerContainer).height() + $(footerContainer).height());
	}

	getContentHeight () {
		var contentContainer = ReactDOM.findDOMNode(this.refs.contentContainer);
		var minContentHeight = this.props.minContentHeight;
		var contentHeight = 0;

		$(contentContainer).find("> *").each(function(i, content) {
			contentHeight += $(content).outerHeight();
		});


		return Math.max(minContentHeight, contentHeight);
	}
}
